module.exports = __webpack_public_path__ + "img/open_account1.04e8ba05.png";